import React, { useState } from "react";
import "./ReviewerLogin.css";
import logo from "../Public/logo.png";
import axios from "axios";
import ENDPOINT_URL from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const ReviewerLogin = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const from =
    location.state?.from?.pathname || "/reviewer/pipelines/applicant";

  // Send OTP
  const handleSendOtp = async () => {
    if (isSending) return;
    setError("");
    setSuccessMsg("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    console.log("API Request: POST /api/reviewer/send-otp", { email });

    try {
      setIsSending(true);
      const res = await axios.post(
        `${ENDPOINT_URL}/api/reviewer/login/request-otp`,
        { email },
        { withCredentials: true }
      );

      console.log("API Response (Send OTP):", res.data);

      setOtpSent(true);
      setSuccessMsg("OTP sent to your email.");
      toast.success("OTP sent.");
    } catch (err) {
      console.error("API Error (Send OTP):", err);
      const msg = err?.response?.data?.error || "Failed to send OTP.";
      setError(msg);
      toast.error(msg);
    } finally {
      setIsSending(false);
    }
  };

  const handleOtpChange = (value, index) => {
    if (value.length > 1) return;

    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);

    if (value && index < 5) {
      document.getElementById(`otp-reviewerlogin-${index + 1}`).focus();
    }
  };

  const handleVerifyOtp = async () => {
    setError("");
    setSuccessMsg("");

    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      setError("Please enter valid OTP.");
      toast.error("Invalid OTP.");
      return;
    }

    console.log("API Request: POST /api/r/verify-otp", {
      email,
      otp: finalOtp,
    });

    try {
      const res = await axios.post(
        `${ENDPOINT_URL}/api/reviewer/login/verify-otp`,
        { email, otp: finalOtp },
        { withCredentials: true }
      );

      const data = res?.data;
      console.log("API Response (Verify OTP):", data);

      if (res.status === 200) {
        localStorage.setItem("reviewer_info", JSON.stringify(data?.reviewer));
        localStorage.setItem("reviewer_token", data.token);
        toast.success("OTP Verified. Redirecting...");
        navigate(from, { replace: true });
      }
    } catch (err) {
      console.error("API Error (Verify OTP):", err);
      const msg = err?.response?.data?.error || "Invalid or expired OTP.";
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="reviewerlogin-page-reviewerlogin">
      {/* SMALL + LEFT SHIFTED LOGO */}
      <div className="reviewerlogin-logo-wrapper-reviewerlogin">
        <img
          src={logo}
          alt="Logo"
          className="reviewerlogin-logo-reviewerlogin"
        />
      </div>

      <div className="reviewerlogin-container-reviewerlogin">
        {!otpSent ? (
          <div className="reviewerlogin-form-reviewerlogin">
            <h2 className="reviewerlogin-title-reviewerlogin">
              Reviewer Login
            </h2>

            <div className="reviewerlogin-form-group-reviewerlogin">
              <label>Email</label>
              <input
                type="text"
                className="reviewerlogin-input-reviewerlogin"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </div>

            {error && (
              <div className="reviewerlogin-error-reviewerlogin">{error}</div>
            )}
            {successMsg && (
              <div className="reviewerlogin-success-reviewerlogin">
                {successMsg}
              </div>
            )}

            <button
              className="reviewerlogin-btn-reviewerlogin"
              onClick={handleSendOtp}
              disabled={isSending}
              style={{ cursor: isSending ? "not-allowed" : "pointer" }}
            >
               {isSending ? (
                <>
                  {/* simple spinner emoji — replace with CSS spinner if you prefer */}
                  <span style={{ marginRight: 8 }}>⏳</span>
                  Sending...
                </>
              ) : (
                "Send OTP"
              )}
            </button>

            <p className="reviewerlogin-footertext-reviewerlogin">
              Already have an account?{" "}
              <span
                className="reviewerlogin-footerlink-reviewerlogin"
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                Login Page
              </span>
            </p>
          </div>
        ) : (
          <div className="reviewerlogin-form-reviewerlogin">
            <h2 className="reviewerlogin-title-reviewerlogin">Enter OTP</h2>

            <p className="reviewerlogin-info-reviewerlogin">
              OTP sent to <b>{email}</b>
            </p>

            <div className="reviewerlogin-otp-container-reviewerlogin">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-reviewerlogin-${index}`}
                  type="text"
                  maxLength="1"
                  className="reviewerlogin-otp-box-reviewerlogin"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                />
              ))}
            </div>

            {error && (
              <div className="reviewerlogin-error-reviewerlogin">{error}</div>
            )}
            {successMsg && (
              <div className="reviewerlogin-success-reviewerlogin">
                {successMsg}
              </div>
            )}

            <button
              className="reviewerlogin-btn-reviewerlogin"
              onClick={handleVerifyOtp}
            >
              Verify OTP
            </button>

            <p
              className="reviewerlogin-resend-reviewerlogin"
              onClick={handleSendOtp}
            >
              Resend OTP
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewerLogin;
